var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_518_493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.82814 13.9988V7.4813C6.82814 6.6218 6.13139 5.92505 5.27189 5.92505H1.40625C1.01794 5.92505 0.703125 6.23986 0.703125 6.62817V12.8532C0.703125 13.2415 1.01794 13.5563 1.40625 13.5563H5.27184C5.84227 13.5562 6.37561 13.7183 6.82814 13.9988ZM4.51875 11.95H3.01252C2.07961 11.9129 2.08031 10.5806 3.01252 10.5438H4.51875C5.45166 10.5809 5.45095 11.9132 4.51875 11.95ZM4.51875 8.93752H3.01252C2.07961 8.90034 2.08031 7.56806 3.01252 7.53127H4.51875C5.45166 7.56844 5.45095 8.90072 4.51875 8.93752Z",
    fill: "#C32A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6562 13.5563C14.0445 13.5563 14.3593 13.2414 14.3593 12.8531V6.62812C14.3593 6.23981 14.0445 5.925 13.6562 5.925H9.79062C8.93112 5.925 8.23438 6.62175 8.23438 7.48125V13.9988C8.68691 13.7183 9.22025 13.5563 9.79062 13.5563H13.6562ZM10.5437 7.53127H12.05C12.9829 7.56844 12.9822 8.90072 12.05 8.93752H10.5437C9.61081 8.90034 9.61152 7.56806 10.5437 7.53127ZM10.5437 10.5438H12.05C12.9829 10.581 12.9822 11.9132 12.05 11.95H10.5437C9.61081 11.9129 9.61152 10.5806 10.5437 10.5438Z",
    fill: "#C32A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0909 10.7497L20.2792 7.93795C20.1246 3.53803 16.5134 0 12.05 0C7.45255 0 4.84962 2.94047 3.82812 4.51875H5.27188C6.17661 4.51875 6.98741 4.92689 7.53125 5.56814C8.07509 4.92684 8.88589 4.51875 9.79062 4.51875H13.6562C14.8193 4.51875 15.7656 5.46502 15.7656 6.62812V12.8531C15.7656 14.0162 14.8193 14.9625 13.6562 14.9625H9.79062C8.93248 14.9625 8.23438 15.6607 8.23438 16.5187C8.18267 17.4998 6.78566 17.4266 6.82611 16.4401L5.15455 23.1263C5.10205 23.3364 5.14925 23.559 5.28247 23.7296C5.41573 23.9002 5.62016 24 5.83667 24H13.9328C14.2554 24 14.5367 23.7804 14.6149 23.4674L15.6115 19.4813H21.0875C21.4758 19.4813 21.7906 19.1664 21.7906 18.7781V13.0444L23.0909 11.744C23.3656 11.4695 23.3656 11.0243 23.0909 10.7497Z",
    fill: "#C32A7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_518_493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.ecd5b1933b61a9bde53e12f5f2139fa8.svg";
export { ForwardRef as ReactComponent };